import React from "react";

import LandingArrowIcon from "../../ui/LandingArrowIcon";
import LandingCheckIcon from "../../ui/LandingCheckIcon";

export default function TariffCard({
    tariff,
    formatPrice,
    t,
}) {
    return (
        <article className="landing-tariff-card">
            <div className="landing-tariff-card__top">
                <div className="landing-tariff-card__heading">
                    <span className="landing-tariff-card__audience">
                        {t(tariff.audienceKey)}
                    </span>

                    <h3 className="landing-tariff-card__name">
                        {t(tariff.nameKey)}
                    </h3>

                    <p className="landing-tariff-card__description">
                        {t(
                            tariff.descriptionKey
                        )}
                    </p>
                </div>
            </div>

            <div className="landing-tariff-card__price">
                <strong>
                    {formatPrice(
                        tariff.price
                    )}
                </strong>

                <span>
                    {t(
                        "main.landing.tariffs.common.perMonth"
                    )}

                    <small>
                        {t(
                            "main.landing.tariffs.common.excludingVat"
                        )}
                    </small>
                </span>
            </div>

            <div className="landing-tariff-card__divider"/>

            <div className="landing-tariff-card__features">
                <div className="landing-tariff-card__features-title">
                    {t(
                        "main.landing.tariffs.common.included"
                    )}
                </div>

                <ul>
                    {tariff.featureKeys.map(
                        (featureKey) => (
                            <li key={featureKey}>
                                <span className="landing-tariff-card__check">
                                    <LandingCheckIcon/>
                                </span>

                                <span>
                                    {t(
                                        featureKey
                                    )}
                                </span>
                            </li>
                        )
                    )}
                </ul>
            </div>

            <a
                className="landing-tariff-card__button"
                href="/register"
            >
                {t(
                    "main.landing.tariffs.common.startFree"
                )}

                <LandingArrowIcon/>
            </a>
        </article>
    );
}
